import { IdNameList } from "../../../../api/services/common/models";
import { MuiGrid, MuiModal } from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { selectReportSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { ReportChangeModalWrapper } from "../../ReportSearchStyle";
import { ReportSearchFormController } from "../reportSearchForm/ReportSearchFormControls";

interface ReportChangeModalProps {
  isOpen: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  reportCategories: IdNameList[];
  reportTypes: IdNameList[];
  handleCategoryChange: (categoryId: string) => void;
}
export const ReportChangeModal = ({
  isOpen,
  onSubmit,
  onCancel,
  reportCategories,
  reportTypes,
  handleCategoryChange,
}: ReportChangeModalProps) => {
  const { useFetchLabel, commonLabels } = useSiteCore();

  const getLabel = useFetchLabel(selectReportSiteCoreKeys.header);

  return (
    <MuiModal
      open={isOpen}
      onClose={onCancel}
      title={getLabel(selectReportSiteCoreKeys.changeReportHeader)}
      primaryButtonTitle={getLabel(selectReportSiteCoreKeys.viewReportsButton)}
      onPrimaryButtonClick={onSubmit}
      secondaryButtonTitle={commonLabels.cancel}
      onSecondaryButtonClick={onCancel}
      hasLargeContent
    >
      <ReportChangeModalWrapper>
        <MuiGrid container columnSpacing={2} rowSpacing={2}>
          <ReportSearchFormController
            reportCategories={reportCategories}
            reportTypes={reportTypes}
            handleCategoryChange={handleCategoryChange}
          />
        </MuiGrid>
      </ReportChangeModalWrapper>
    </MuiModal>
  );
};
